var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselPlusCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 6.13574C43.9917 6.13576 54.9716 17.1158 54.9717 30.6074C54.9717 44.0992 43.9918 55.0791 30.5 55.0791C17.0082 55.0791 6.02832 44.0992 6.02832 30.6074C6.02843 17.1157 17.0083 6.13574 30.5 6.13574ZM30.5 9.72363C18.9818 9.72363 9.61632 19.0893 9.61621 30.6074C9.61621 42.1257 18.9818 51.4912 30.5 51.4912C42.0182 51.4912 51.3838 42.1256 51.3838 30.6074C51.3837 19.0893 42.0182 9.72365 30.5 9.72363ZM30.5 19.7529C31.4868 19.7529 32.2939 20.5611 32.2939 21.5479V28.8135H39.5781C40.5648 28.8135 41.372 29.6208 41.3721 30.6074C41.3721 31.5942 40.5649 32.4014 39.5781 32.4014H32.2939V39.6855C32.2939 40.6723 31.4868 41.4805 30.5 41.4805C29.5132 41.4805 28.7061 40.6723 28.7061 39.6855V32.4014H21.4395C20.4528 32.4012 19.6455 31.5941 19.6455 30.6074C19.6456 29.6208 20.4529 28.8136 21.4395 28.8135H28.7061V21.5479C28.7061 20.5611 29.5132 19.7529 30.5 19.7529Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselPlusCard);
export default __webpack_public_path__ + "static/media/carousel_plus_card.9521a6ff211dbaeed8a77f218e8bdd39.svg";
export { ForwardRef as ReactComponent };